// Estado de MekaFix Pro del CLIENTE en el front. Espejo de isClientProUser en
// functions/src/ai.js — mantener en sincronía a mano. Tres vías:
//  1. Suscripción legacy (subscriptionStatus/Plan = client_pro).
//  2. Riel nuevo clientProStatus/clientProExpiry (lo escribirá el checkout de Azul).
//  3. Regalo de fundador: APAGADO desde el 2026-08-10 (decisión del dueño).
import { loadLaunchConfig } from './launchConfig';

// EN CERO = APAGADO. Espejo exacto de `FOUNDER_PRO_DAYS` en functions/src/ai.js,
// y del knob `config/launch.founderProDays` que lo vuelve a encender sin
// desplegar. Los dos lados TIENEN que decir lo mismo: si el backend deja de
// regalar Pro y esta copia sigue en 90, la pantalla le promete al fundador un
// beneficio que el servidor ya no le da — y el usuario lo descubre cuando se le
// acaba el saldo de IA a mitad de una conversación, que es el peor momento.
export const FOUNDER_PRO_DAYS = 0;

function toDate(v) {
  if (!v) return null;
  if (v.toDate) return v.toDate();
  const d = new Date(v);
  return isNaN(d.getTime()) ? null : d;
}

// Devuelve { isPro, via: 'subscription' | 'founder' | null, until: Date | null }
export async function getClientProState(profile) {
  if (!profile) return { isPro: false, via: null, until: null };
  if (profile.subscriptionStatus === 'active' && profile.subscriptionPlan === 'client_pro') {
    return { isPro: true, via: 'subscription', until: toDate(profile.clientProExpiry) };
  }
  const expiry = toDate(profile.clientProExpiry);
  if (profile.clientProStatus === 'active' && expiry && expiry > new Date()) {
    return { isPro: true, via: 'subscription', until: expiry };
  }
  const role = profile.role || profile.userType || 'client';
  if (profile.founder === true && role === 'client') {
    const launch = await loadLaunchConfig();
    // El knob manda sobre la constante, igual que en el backend. Un valor que no
    // sea un número positivo deja el regalo apagado, que es el estado seguro.
    const dias = typeof launch?.founderProDays === 'number' && launch.founderProDays >= 0
      ? launch.founderProDays
      : FOUNDER_PRO_DAYS;
    const opened = toDate(launch && launch.openedAt);
    if (dias > 0 && opened) {
      const until = new Date(opened.getTime() + dias * 24 * 60 * 60 * 1000);
      if (until > new Date()) return { isPro: true, via: 'founder', until };
    }
  }
  return { isPro: false, via: null, until: null };
}

// Tope de vehículos del cliente gratis.
export const FREE_VEHICLE_LIMIT = 3;

/**
 * ¿Puede este perfil registrar un vehículo más?
 * Solo el CLIENTE gratis tiene tope. Antes el tope se evaluaba a mano mirando
 * únicamente la suscripción legacy, así que el Pro que pagaba por Azul y el
 * fundador con el regalo seguían topados en 3 pese a tener el beneficio.
 */
export async function canAddVehicle(profile, currentCount) {
  const role = profile?.role || profile?.userType || 'client';
  if (role !== 'client') return true;
  const { isPro } = await getClientProState(profile);
  if (isPro) return true;
  return (currentCount || 0) < FREE_VEHICLE_LIMIT;
}
